// extracted by mini-css-extract-plugin
export default {"news":"Main_news__FAXQA","news__list":"Main_news__list__zp4Dm","news__empty":"Main_news__empty__Yh11K"};